import React from 'react'

import Wysiwyg from '~/components/core/Wysiwyg/Wysiwyg'
import ContactItem from '~/components/core/contactItem'
import Accordion from '~/components/core/accordion'
import ButtonArrow from '~/components/core/buttonArrow'
import transformLink from '~/utils/transformLink'

const AccordionList = ({ data }) => {
  let cta = null

  if (data.cta !== null && data.cta !== undefined) {
    cta = data.cta.fields ? data.cta.fields : data.cta
  }

  const { url, contentTypeContentful } = transformLink(cta, true, false)

  return (
    <div className="accordion-slice">
      <div className="row">
        <div className="col-12 lg-col-8 lg-col-offset-1 xl-col-6 xl-col-offset-2">
          {data.titleContent && data.titleContent !== '' && (
            <h2 className="title-block text-blue">{data.titleContent}</h2>
          )}
          {data.items.map((item, i) => {
            const accordion = item.fields ? item.fields : item
            const content = accordion.content

            let ctaItem = null

            if (accordion.cta !== null && accordion.cta !== undefined) {
              ctaItem = accordion.cta.fields
                ? accordion.cta.fields
                : accordion.cta
            }

            const subLink = transformLink(ctaItem, true, false)
            const urlItem = subLink.url
            const contentTypeContentfulItem = subLink.contentTypeContentful

            return (
              <Accordion
                key={i}
                type="title"
                titleLevel={data.titleContent ? 3 : 2}
                prefixClass="accordion-slice"
                button={accordion.title}
                buttonType="maths"
              >
                <>
                  <span className="title-block block text-blue">
                    {accordion.subtitle1}
                  </span>

                  <Wysiwyg
                    document={content}
                    classes={
                      !accordion.subtitle2 && !accordion.contactItems
                        ? 'mb-7 md:mb-8'
                        : ''
                    }
                  />

                  {accordion.subtitle2 && (
                    <span className="title-block block text-blue mt-8">
                      {accordion.subtitle2}
                    </span>
                  )}

                  {accordion.contactItems && (
                    <div className="flex flex-wrap">
                      {accordion.contactItems.map((contactItem, i) => {
                        return (
                          <div
                            className="md:w-1/2 mb-7 md:mb-8 md:pr-8"
                            key={i}
                          >
                            <ContactItem type="accordion" data={contactItem} />
                          </div>
                        )
                      })}
                    </div>
                  )}

                  {ctaItem !== null && (
                    <div className="mt-6 md:mt-8 mb-7 md:mb-8">
                      <ButtonArrow
                        text={ctaItem.label}
                        link={urlItem}
                        contentType={contentTypeContentfulItem}
                        color="purple"
                      />
                    </div>
                  )}
                </>
              </Accordion>
            )
          })}

          {cta !== null && (
            <div className="mt-6 md:mt-8">
              <ButtonArrow
                text={cta.label}
                link={url}
                contentType={contentTypeContentful}
                color="purple"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default AccordionList
